import React from 'react';
import Middle2 from "../Component/Mddle2";

const Disclaimer = () => {
  return (
      <>
        <Middle2 title="Disclaimer" page="Disclaimer" img="assets/img/page-header1.jpg" />
      <div className="tw-max-w-3xl tw-mx-auto tw-p-6 tw-border tw-rounded-lg tw-shadow-lg tw-mt-8">
        <h1 className="tw-text-2xl tw-font-bold tw-text-center tw-mb-6">Disclaimer for Yadu Nandan Shiksha Seva Sansthan Trust</h1>
        <p className="tw-mb-4">
          If you require any more information or have any questions about our site's disclaimer, please feel free to contact us by email at
          <a href="mailto:lpss@yadutrust.org" className="tw-text-blue-500 tw-underline"> lpss@yadutrust.org</a>.
        </p>
        <h2 className="tw-text-xl tw-font-semibold tw-mb-4">Disclaimers for www.yadutrust.org</h2>
        <p className="tw-mb-4">
          All the information on this website - <a href="https://yadutrust.org" className="tw-text-blue-500 tw-underline">https://yadutrust.org</a> - is published in good faith and for general information purpose only.
          www.yadutrust.org does not make any warranties about the completeness, reliability and accuracy of this information. Any action you take upon the
          information you find on this website (www.yadutrust.org), is strictly at your own risk. www.yadutrust.org will not be liable for any losses and/or damages
          in connection with the use of our website.
        </p>
        <p className="tw-mb-4">
          From our website, you can visit other websites by following hyperlinks to such external sites. While we strive to provide only quality links to useful and ethical websites,
          we have no control over the content and nature of these sites. These links to other websites do not imply a recommendation for all the content found on these sites.
          Site owners and content may change without notice and may occur before we have the opportunity to remove a link which may have gone 'bad'.
        </p>
        <p className="tw-mb-4">
          Please be also aware that when you leave our website, other sites may have different privacy policies and terms which are beyond our control. Please be sure to check the
          Privacy Policies of these sites as well as their "Terms of Service" before engaging in any business or uploading any information.
        </p>
        <h2 className="tw-text-xl tw-font-semibold tw-mb-4">Consent</h2>
        <p className="tw-mb-4">
          By using our website, you hereby consent to our disclaimer and agree to its terms.
        </p>
        <h2 className="tw-text-xl tw-font-semibold tw-mb-4">Update</h2>
        <p className="tw-mb-4">
          Should we update, amend or make any changes to this document, those changes will be prominently posted here.
        </p>
      </div>
        </>
  );
};

export default Disclaimer;